<!-- BANNER -->
<section class="banner_Section">
    <ngb-carousel interval="50000" [showNavigationArrows]="sharedContentsList?.length > 1"
        [showNavigationIndicators]="sharedContentsList?.length > 1">
        <ng-template *ngFor="let hero of sharedContentsList" ngbSlide>
            <div class="hero-image">
                <img [src]="hero?.image" alt="Random first slide" />
            </div>
            <div class="carousel-caption">
                <div class="bnrtxt">
                    <div class="container">
                        <div class="bnrtxtinr">
                            <h1>
                                <span class="yellow headerLevel3">{{ hero.heading }}</span><br />

                                <span class="headerLevel2">{{ hero.subHeading }}</span>
                            </h1>
                            <button (click)="navigatetoPage($event, hero)"
                                class="btn primary-ebtn py-3 no-background-change">{{
                                hero.navigationText }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </ngb-carousel>
</section>